module.exports = __webpack_public_path__ + "static/media/pending.4fa3f00f.png";